import React, { useContext, useEffect, useRef } from "react";
import styles from "./Main.module.scss";
import ParticlesLayer from '../../components/ParticlesLayer';
import SlidesMain from '../../components/SlidesMain';
import Map from '../../components/Map';
import PathContext from "../../context/path";
import StateContext from "../../context/state";
const Main = () => {
  
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const {updatePlayPopup, popup } = state;
  const refPopup = useRef(null);
  const refPopupVideo = useRef(null);
  useEffect(()=>{
    const popupElement = refPopup.current;
    const popupVideo = refPopupVideo.current;
    let timer = null;
    if(popup){
      popupElement.classList.add(styles.open);
      setTimeout(() => {
        popupVideo.play();
      }, 500);
    }else{
      popupElement.classList.remove(styles.open);
      popupVideo.pause();
    }
    return ()=>{
      clearTimeout(timer);
    }
  }, [popup]);
  return (
    <>
    <div className={styles.popup} ref={refPopup}>
          <div className={styles.popup__close} onClick={()=>{updatePlayPopup(false)}}>
            <svg width="126" height="126" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3L123 123" stroke="#67D672" strokeWidth="5" strokeLinecap="round" />
              <path d="M123 3L3 123" stroke="#67D672" strokeWidth="5" strokeLinecap="round" />
            </svg>

          </div>
          <div className={styles.popup__video}>
            <video src={`${path}/video/UTLC_2023_rus.mp4`} controls ref={refPopupVideo}></video>
          </div>
        </div>
      <div className={styles.wrap}>
        <div className={styles.particles}>
          <ParticlesLayer type={'main'}/>
        </div>
        <div className={styles.slides}>
          <SlidesMain />
        </div>
        <div className={styles.map}>
          <Map />
        </div>
      </div>
    </>
  );

}

export default Main;
